import { setPreStyleGuideTheme } from "@insite/client-framework/ThemeConfiguration";
import {
    accordion,
    button,
    checkbox,
    dataTable,
    datePicker,
    drawer,
    dynamicDropdown,
    formField,
    link,
    loadingSpinner,
    menu,
    modal,
    overflowMenu,
    pagination,
    radio,
    select,
    tag,
    textField,
    toast,
    tooltip,
    typography,
} from "@solveindustrial/Utilities/styleguide";
import { colorPalette, colorStrings } from "@solveindustrial/Utilities/variables";

const setPreStyles = () => {
    // Add some post styleguide customizations. These cannot be overridden by the style guid.
    setPreStyleGuideTheme({
        accordion,
        button,
        colors: colorPalette,
        dataTable: dataTable(),
        dynamicDropdown: dynamicDropdown(),
        drawer,
        header: {
            backgroundColor: colorStrings.primaryMain,
            isDropShadow: true,
            dropShadowStyle: "dark",
        },
        /* Fields section - START */
        formField,
        datePicker,
        checkbox,
        radio,
        select,
        textField,
        /* Fields section - END */
        link,
        loadingSpinner,
        menu,
        modal,
        overflowMenu,
        pagination,
        tag,
        toast,
        tooltip,
        typography,
    });
};

export default setPreStyles;
